export default {
  dialogTitle: "批量加入看板",
  tradingBoard: {
    title: "交易数据看板",
    info: "加入后可在交易数据里查看",
  },
  balanceBoard: {
    title: "余额数据看板",
    info: "加入后可在余额数据里查看",
  },
  addBoth: {
    title: "同时加入",
    info: "同时加入余额看板和交易看板",
  },
};
